export default __webpack_public_path__ + "static/kantyna-3e1cf1dd85456cc7fdd471b8b1ab13a6.png";